import { render, staticRenderFns } from "./yixiubao.vue?vue&type=template&id=34cd1207&scoped=true"
import script from "./yixiubao.vue?vue&type=script&lang=js"
export * from "./yixiubao.vue?vue&type=script&lang=js"
import style0 from "./yixiubao.vue?vue&type=style&index=0&id=34cd1207&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cd1207",
  null
  
)

export default component.exports